var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "form",
      {
        ref: _vm.refFormOpenHours,
        on: {
          submit: function ($event) {
            $event.preventDefault()
          },
        },
      },
      [
        _c("div", { staticClass: "emd-panel" }, [
          _c("div", { staticClass: "emd-panel__section" }, [
            _c("div", { staticClass: "emd-panel__block" }, [
              _c("div", { staticClass: "el-chunk" }, [
                _c(
                  "h2",
                  { staticClass: "emd-label _required open-hours__title" },
                  [_vm._v(" " + _vm._s(_vm.$t("title")) + " ")]
                ),
                _c(
                  "span",
                  { staticClass: "emd-text _size_small _color_nonessential" },
                  [_vm._v(" " + _vm._s(_vm.$t("description")) + " ")]
                ),
              ]),
            ]),
            _c(
              "div",
              { staticClass: "emd-panel__block" },
              [
                _vm._l(_vm.form.entries(), function ([index, item]) {
                  return _c(
                    "div",
                    {
                      key: item.name,
                      staticClass: "emd-form-group eu-flex eu-no-margin",
                    },
                    [
                      _c("open-hours-input", {
                        ref: item.name,
                        refInFor: true,
                        attrs: {
                          id: "id" + item.name,
                          disabled: _vm.disabled,
                          value: item,
                        },
                      }),
                      _vm.showCopy(item)
                        ? _c("copy-to-all", {
                            attrs: { "data-testid": "copy-to-all", item: item },
                            on: {
                              click: function ($event) {
                                return _vm.showModal(item)
                              },
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  )
                }),
                _vm.copyToAllModalVisible
                  ? _c("copy-toall-confirmation-modal", {
                      attrs: {
                        show: _vm.copyToAllModalVisible,
                        item: _vm.currentDay,
                      },
                      on: {
                        onCancel: _vm.handleClose,
                        onCopy: _vm.handleCopyAll,
                      },
                    })
                  : _vm._e(),
              ],
              2
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }